import React from "react";
import AuthGuard from "./AuthGuard";
import RoleGuard from "./RoleGuard";
import type { UserRole } from "../types/auth.types";

interface SecureRouteProps {
  children: React.ReactNode;
  /** Look up allowed roles from routePermissions.ts by path */
  permissionPath?: string;
  /** Explicit exact backend roles when not using permissionPath */
  allowedRoles?: UserRole[];
}

/**
 * Combines AuthGuard + RoleGuard for a single route element.
 */
const SecureRoute: React.FC<SecureRouteProps> = ({
  children,
  permissionPath,
  allowedRoles,
}) => {
  return (
    <AuthGuard>
      <RoleGuard permissionPath={permissionPath} allowedRoles={allowedRoles}>
        {children}
      </RoleGuard>
    </AuthGuard>
  );
};

export default SecureRoute;
